import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

const amenityPendingOrderKey = 'Pending_Amenity_';

class amenityStore {

    // Main Properties

    @observable menu = null;
    @observable amenityItems = [];
    @observable amenityFilterItems = [];
    @observable amenityPendingOrders = [];
    @observable amenityRemark = '';
    @observable amenitySearchText = '';
    @observable amenitySearchSubCategory = 'All';
    @observable amenityTotalOrder = 0;

    // Amenity Detail Modal

    @observable amenityDetail = null;
    @observable showAmenityDetailModal = false;

    // Amenity Tab

    @observable amenityTabLoading = false;
    @observable amenityTabCategories = [];
    @observable amenityTabSubCategories = [];
    @observable amenityTabCategoryIdActive = '0';

    // Amenity Confirm

    @observable amenitySubTotal = 0;
    @observable amenityVat = 0;
    @observable amenityVatTax = 0;
    @observable amenityServiceFee = 0;
    @observable amenityServiceFeeTax = 0;
    @observable amenityTotal = 0;

    @observable amenityTimeSelected = 'now';
    @observable amenityTimeDeliver = '';
    @observable amenityTimeDeliverDate = '';

    // Swipe
    @observable swipeX = 0;
    @observable isSwipe = false;

    // Initialization

    @action initGetAmenities(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getAmenities(languageCode).then((amenityResponses) => {
            if (amenityResponses) {
                that.menu = amenityResponses.menu;
                that.amenityTabCategories = amenityResponses.categoryNames;
                that.amenityTabSubCategories = that.amenityTabCategories[0].subCategories;

                if (that.amenityTabCategoryIdActive === '0') {
                    that.amenityTabCategoryIdActive = that.amenityTabCategories[0].taskId.toString();
                }

                that.amenityItems = amenityResponses.items;
                that.amenityFilterItems = that.amenityItems;

                if (that.amenityFilterItems.length > 0) {
                    that.amenityFilterItems.map((amenityItem) => {
                        return amenityItem.orderQuantity = 0;
                    });

                    const amenityOrders = this.getAmenityPendingOrdersFromStorage(roomNo);
                    if (amenityOrders !== null) {
                        amenityOrders.map((amenityOrder) => {
                            let amenityItem = that.amenityFilterItems.find(it => it.taskId === amenityOrder.taskId);
                            if (amenityItem) {
                                amenityItem.orderQuantity = amenityOrder.orderQuantity;
                            }
                            return amenityItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.amenityTabCategories = [];
                that.amenityTabSubCategories = [];
                that.amenityItems = [];
                that.amenityFilterItems = [];
                that.amenitySearchText = '';
                that.amenitySearchSubCategory = 'All';
            }

            this.searchAmenityByNameAndSubCategory();
        });
    }

    @action refreshAmenities(roomNo) {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getAmenities(languageCode).then((amenityResponses) => {
            if (amenityResponses) {
                that.menu = amenityResponses.menu;
                that.amenityTabCategories = amenityResponses.categoryNames;
                that.amenityTabSubCategories = that.amenityTabCategories[0].subCategories;

                if (that.amenityTabCategoryIdActive === '0') {
                    that.amenityTabCategoryIdActive = that.amenityTabCategories[0].taskId.toString();
                }

                that.amenityItems = amenityResponses.items;
                that.amenityFilterItems = that.amenityItems;

                if (that.amenityFilterItems.length > 0) {
                    that.amenityFilterItems.map((amenityItem) => {
                        return amenityItem.orderQuantity = 0;
                    });

                    const amenityOrders = this.getAmenityPendingOrdersFromStorage(roomNo);
                    if (amenityOrders !== null) {
                        amenityOrders.map((amenityOrder) => {
                            let amenityItem = that.amenityFilterItems.find(it => it.taskId === amenityOrder.taskId);
                            if (amenityItem) {
                                amenityItem.orderQuantity = amenityOrder.orderQuantity;
                            }
                            return amenityItem;
                        })
                    }
                }
            } else {
                that.menu = null;
                that.amenityTabCategories = [];
                that.amenityTabSubCategories = [];
                that.amenityItems = [];
                that.amenityFilterItems = [];
                that.amenitySearchText = '';
                that.amenitySearchSubCategory = 'All';
            }

            this.searchAmenityByNameAndSubCategory();
        });
    }

    @action initAmenityConfirm(roomNo) {
        this.amenityRemark = '';
        this.amenityTimeSelected = 'now';
        this.amenityTimeDeliver = '';

        let data = LocalStorage.Get(amenityPendingOrderKey + roomNo);
        if (data !== null) {
            this.amenityPendingOrders = data;
        }

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CmsTasks.getAmenities(languageCode).then(resp => {
            this.menu = resp.menu;

            this.amenityVatTax = resp.menu.vat;
            this.amenityServiceFeeTax = resp.menu.serviceFee;

            this.setAmenityPriceDetail();
        });
    }

    @action initTotalAmenityOrder(roomNo) {
        const orders = LocalStorage.Get(amenityPendingOrderKey + roomNo);

        if (orders) {
            let quantity = 0;
            orders.map(order => {
                quantity = quantity + order.orderQuantity;

                return order;
            });

            this.amenityTotalOrder = quantity;
        } else {
            this.amenityTotalOrder = 0;
        }
    }

    // Transaction Action

    @action goToAmenityConfirmPage(roomNo) {
        let items = this.amenityItems.filter(item => item.orderQuantity > 0);
        LocalStorage.Save(amenityPendingOrderKey + roomNo, items);
        return LocalStorage.Get(amenityPendingOrderKey + roomNo);
    }

    // @action goToAmenityConfirmPageFromRetailOffer(roomNo, taskId) {
    //     return this.refreshAmenities(roomNo).then(() => {
    //         let item = this.amenityItems.find(item => item.taskId === taskId);
    //         item.orderQuantity = item.orderQuantity + 1;
    //         let items = this.amenityItems.filter(item => item.orderQuantity > 0);
    //         LocalStorage.Save(amenityPendingOrderKey + roomNo, items);
    //         LocalStorage.Get(amenityPendingOrderKey + roomNo);
    //     });
    // }

    @action removeAmenityOrders(roomNo) {
        this.amenityItems = [];
        this.amenityFilterItems = this.amenityItems;
        LocalStorage.Remove(amenityPendingOrderKey + roomNo);
    }

    @action backToAmenityMainPage(roomNo) {
        const amenityPendingOrders = this.amenityPendingOrders.filter(item => item.orderQuantity > 0);

        if (amenityPendingOrders) {
            LocalStorage.Save(amenityPendingOrderKey + roomNo, amenityPendingOrders);
        } else {
            LocalStorage.Save(amenityPendingOrderKey + roomNo, []);
        }
    }

    // GET Properties

    @action getAmenitiesByTaskId(taskId) {
        const amenityItem = this.amenityItems.find(it => it.taskId === taskId);

        this.amenityDetail = amenityItem;
        this.showAmenityDetailModal = true;

        return amenityItem;
    }

    @action getAmenityPendingOrders() {
        return this.amenityPendingOrders.filter(it => it.orderQuantity > 0);
    }

    @action getAmenityPendingOrdersFromStorage(roomNo) {
        return LocalStorage.Get(amenityPendingOrderKey + roomNo);
    }

    // Set Properties

    @action setAmenityRemark(value) {
        this.amenityRemark = value;
    }

    @action setAmenityItemQty(taskId, value) {
        const amenityItem = this.amenityItems.find(it => it.taskId === taskId);
        amenityItem.orderQuantity = value;

        let quantity = 0;

        this.amenityItems.map(item => {
            quantity = quantity + item.orderQuantity;
            return item;
        });

        this.amenityTotalOrder = quantity;
    }

    @action setAmenityPendingOrderQty(taskId, value) {
        const amenityPendingOrder = this.amenityPendingOrders.find(it => it.taskId === taskId);
        amenityPendingOrder.orderQuantity = value;

        this.setAmenityPriceDetail();
    }

    @action setShowAmenityDetailModal(value) {
        this.showAmenityDetailModal = value;
    }

    @action setAmenityPriceDetail() {
        this.amenitySubTotal = 0;

        this.amenityPendingOrders.map((order) => {
            this.amenitySubTotal = this.amenitySubTotal + (order.orderQuantity * order.price);
            return this.amenitySubTotal;
        });

        this.amenityServiceFee = this.amenitySubTotal * this.amenityServiceFeeTax / 100;
        this.amenityVat = (this.amenitySubTotal + this.amenityServiceFee) * this.amenityVatTax / 100;
        this.amenityTotal = this.amenitySubTotal + this.amenityVat + this.amenityServiceFee;
    }

    @action setAmenityTimeSelected(value) {
        this.amenityTimeSelected = value;
        this.amenityTimeDeliver = '';
    }

    @action setAmenityTimeDeliver(value) {
        this.amenityTimeDeliver = value;
        this.amenityTimeSelected = '';
    }

    @action setAmenityTimeDeliverDate(value) {
        this.amenityTimeDeliverDate = value;
    }

    @action searchAmenityByNameAndSubCategory() {
        if (this.amenitySearchText === '' && this.amenitySearchSubCategory === 'All') {
            this.amenityFilterItems = this.amenityItems;
            return;
        }

        if (this.amenitySearchSubCategory === 'All') {
            this.amenityFilterItems = this.amenityItems;
        } else {
            this.amenityFilterItems = this.amenityItems.filter(item => {
                let subCategoryName = item.subCategoryName.toLowerCase();
                return subCategoryName.indexOf(this.amenitySearchSubCategory.toLowerCase()) !== -1;
            });
        }

        if (this.amenitySearchText !== '') {
            this.amenityFilterItems = this.amenityFilterItems.filter(item => {
                let itemTaskName = item.taskName.toLowerCase();
                return itemTaskName.indexOf(this.amenitySearchText.toLowerCase()) !== -1;
            });
        }
    }

    @action setAmenitySearchText(value) {
        this.amenitySearchText = value;
    }

    @action setAmenitySearchSubCategory(value) {
        this.amenitySearchSubCategory = value;
    }

    @action setAmenityTabSubCategoriesByTabCategoryTaskId(tabCategoryTaskId) {
        this.amenityTabCategoryIdActive = tabCategoryTaskId.toString();
        const category = this.amenityTabCategories.find(fi => fi.taskId === parseInt(tabCategoryTaskId));

        if (category) {
            if (category.subCategories.length > 0) {
                this.amenityTabSubCategories = category.subCategories;
                return;
            }
        }

        this.amenityTabSubCategories = [];
    }

    @action setSwipeX(value) {
        this.swipeX = value;
    }

    @action setIsSwipe(value) {
        this.isSwipe = value;
    }

    // RESET Properties

    @action resetData() {
        this.menu = null;
        this.showAmenityDetailModal = false;
        this.amenityTabCategories = [];
        this.amenityTabSubCategories = [];
        this.amenityItems = [];
        this.amenityFilterItems = [];
        this.amenitySearchText = '';
        this.amenitySearchSubCategory = 'All';
        this.searchAmenityByNameAndSubCategory();
    }
}

export default new amenityStore()